const HEX_COLOR_PATTERN = /^#([0-9a-fA-F]{6})$/;

export const normalizeColorDropdownPickerHex = (value: string): string | null => {
  const match = HEX_COLOR_PATTERN.exec(value.trim());

  if (!match) {
    return null;
  }

  return `#${match[1].toUpperCase()}`;
};
